import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { computed, type Ref } from 'vue'

/**
 * Функция загрузки файла
 */
export const useUploadFieldFiles = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.file(`/inventory/objects/doc/files`, data.files)
    },
  })

  const upload = async (data: any) => {
    try {
      const result = await mutation.mutateAsync(data)
      addSuccess(trs('itf.saved'))

      return result
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    upload,
  }
}

/**
 * Функция удаления файла
 */
export const useRemoveFieldFiles = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.del(`/inventory/objects/doc/files`, data)
    },
  })

  const remove = async (data: any) => {
    try {
      const result = await mutation.mutateAsync(data)
      addSuccess(trs('itf.removed_file'))

      return result
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}

/**
 * Функция получения файла для скачивания
 */
export const useDownloadFieldFile = (fileName: Ref<string | null>) => {
  const http = useHttp()

  const url = computed(() => `/inventory/objects/doc/files/${fileName.value}`)

  return useQuery({
    queryKey: ['download_field_file'],
    queryFn: () => http.get(url.value, null, { responseType: 'arraybuffer' }),
    retry: false,
    enabled: false,
  })
}
